import useToast from './useToast'

// Fallback copy by HTTP status, used when the API response carries no message.
const STATUS_FALLBACKS = {
    401: 'Your session has expired. Please sign in again.',
    403: 'You don’t have permission to perform this action.',
    419: 'Your session has expired. Please sign in again.',
}

const fallbackFor = (status) => {
    if (STATUS_FALLBACKS[status]) return STATUS_FALLBACKS[status]
    if (status >= 500) return 'Something went wrong on our end. Please try again later.'
    return 'An error occurred'
}

export default function showApiError(error) {
    const status = error?.response?.status
    useToast().showError(error, fallbackFor(status))
}
